<app-page-header [pageHeader]="pageHeader"></app-page-header>

<app-breadcrumb *ngIf="!isLoading" [tag]="tag"></app-breadcrumb>

<div class="section-page">
  <div class="container">
    <div class="categories">
      <div class="item">
        <div class="collapse show" id="collapseFAQ">
          <div *ngIf="isLoading" class="loading-container">
            <div class="spinner"></div>
            <p>Carregando...</p>
          </div>
          <!-- ngIf temporario para poder ser feito a paginação -->
          <div class="content" *ngIf="paginatedArticles !== undefined && !isLoading">
            <ul class="list-unstyled">
              <li *ngFor="let article of paginatedArticles.artigos; let i = index">
                <hr *ngIf="i === 0" />
                <app-article-summary [articleSummary]="article"></app-article-summary>
                <hr />
              </li>
            </ul>
            <div class="custom-pagination-wrapper">
              <p-paginator
                [rows]="pageSize"
                [totalRecords]="count"
                [rowsPerPageOptions]="[10, 25, 50]"
                [showCurrentPageReport]="false"
                [first]="(page - 1) * pageSize"
                (onPageChange)="handlePageChange($event)"
              ></p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
